/* GPX-CRO: in-my-size fallback filter (client-side, used while the native
   filter.p.m.custom.available_sizes facet is not yet enabled in Search & Discovery).
   REWORK 2026-09-16: custom.available_sizes is the single source of truth (backfilled by a
   Shopify Flow, verified 0 mismatches). data-gpx-sizes on every card comes straight from that
   metafield (see snippets/product-grid-item6.liquid) — no variant-name guessing anymore.
   A blank data-gpx-sizes now means "genuinely out of stock in every size" (confirmed by the
   backfill), so those cards ARE hidden when a size filter is active (no more "always show"
   exception). The collection section renders every product in the collection in one page
   (limit=250, above every one of women/men/kids-boys' real product counts), so this filter
   operates over the FULL collection, not just the first 50 — no page-2+ gap. Remembers the
   chosen size across collections via localStorage. */
(function () {
  var LS_KEY = 'gpx_in_my_size';
  var CARD_SELECTOR = '[data-gpx-sizes]';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var bar = document.querySelector('[data-gpx-inmysize]');
    if (!bar) return;
    var chipsWrap = bar.querySelector('[data-gpx-chips]');
    if (!chipsWrap || chipsWrap.getAttribute('data-native') === '1') return; // native filter handles it

    var chips = Array.prototype.slice.call(chipsWrap.querySelectorAll('.gpx-chip[data-size]'));
    var clearBtn = chipsWrap.querySelector('[data-gpx-clear]');
    var active = null;
    var raf = null;

    function cards() {
      return Array.prototype.slice.call(document.querySelectorAll(CARD_SELECTOR));
    }
    function sizesOf(card) {
      return (card.getAttribute('data-gpx-sizes') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    }
    function applyFilter() {
      cards().forEach(function (c) {
        if (!active) { c.classList.remove('gpx-size-hide'); return; }
        var has = sizesOf(c).indexOf(active) !== -1;
        c.classList.toggle('gpx-size-hide', !has);
      });
    }
    function updateCounts() {
      var all = cards();
      chips.forEach(function (chip) {
        var size = chip.getAttribute('data-size');
        var n = 0;
        for (var i = 0; i < all.length; i++) { if (sizesOf(all[i]).indexOf(size) !== -1) n++; }
        var countEl = chip.querySelector('[data-gpx-count]');
        if (countEl) countEl.textContent = '(' + n + ')';
        // never hide the currently active chip even if the count is 0
        if (n === 0 && size !== active) chip.setAttribute('data-empty', '1');
        else chip.removeAttribute('data-empty');
      });
      if (clearBtn) clearBtn.hidden = !active;
    }
    function setUrlParam(size) {
      try {
        var url = new URL(window.location.href);
        if (size) url.searchParams.set('in_my_size', size);
        else url.searchParams.delete('in_my_size');
        history.replaceState(null, '', url);
      } catch (e) { /* noop */ }
    }
    function setActive(size) {
      active = size || null;
      chips.forEach(function (chip) {
        chip.classList.toggle('is-active', chip.getAttribute('data-size') === active);
      });
      applyFilter();
      updateCounts();
      setUrlParam(active);
      try {
        if (active) localStorage.setItem(LS_KEY, active);
        else localStorage.removeItem(LS_KEY);
      } catch (e) { /* private mode / storage blocked */ }
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var size = chip.getAttribute('data-size');
        setActive(active === size ? null : size);
      });
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { setActive(null); });

    // restore persisted choice, but only if this collection's vocabulary actually has that chip
    var stored = null;
    try { stored = localStorage.getItem(LS_KEY); } catch (e) { /* noop */ }
    var storedChip = stored && chips.filter(function (c) { return c.getAttribute('data-size') === stored; })[0];
    if (storedChip) setActive(stored);
    else updateCounts();

    // re-apply on infinite-scroll / ajax-loaded cards (belt-and-suspenders; with limit=250
    // the whole collection is already in the DOM for women/men/kids-boys today)
    var observer = new MutationObserver(function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        applyFilter();
        updateCounts();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
